import Watcher from '../watcher';
const watcher = new Watcher();

$('#footer .legal .emerge').each((index, ele) => {
    watcher.add({
        element: ele,
        onAppearing(element, direction) {
            $(ele).addClass('emerge-show');
        },
        onDisappeared(element, direction) {
            if (direction == -1) {
                $(ele).removeClass('emerge-show');
            }
        },
    });
});

if ($('#footer .naw').length) {
    watcher.add({
        element: $('#footer .naw')[0],
        onAppearing(element, direction) {
            $(element).find('.emerge-letters').addClass('emerge-show');
        },
        onDisappeared(element, direction) {
            if (direction == -1) {
                $(element).find('.emerge-letters').removeClass('emerge-show');
            }
        },
    });
}
